/* ===============================
   SEAT STYLE DATABASE
================================ */

window.SEAT_STYLE_DB = {
  "2022": {
    "BMW": {
      "X5": {

        /* -----------------
           FIRST ROW
        ------------------ */
        first_row: [
          {
            id: "F313",
            name: "Buckets",
            price: 330.40,
            compare_at: 472.00,
            image: "https://www.nwseatcovers.com/uploads/seats/full/img570e7cbf7c846.gif",
            features: [
              "Adjustable Headrests",
              "Free Map Pockets",
              "Side Airbag Accommodations"
            ]
          },
          {
            id: "F314",
            name: "Buckets w/ Console",
            price: 330.40,
            compare_at: 472.00,
            image: "https://www.nwseatcovers.com/uploads/seats/full/img570e7cbf85147.gif",
            features: [
              "Center Console Access",
              "Adjustable Headrests",
              "Side Airbag Accommodations"
            ]
          },
          {
            id: "F315",
            name: "Sport Buckets",
            price: 360.40,
            compare_at: 510.00,
            image: "https://www.nwseatcovers.com/uploads/seats/full/img570e7cbf9c84a.gif",
            features: [
              "Sport Bolsters",
              "Adjustable Headrests",
              "Premium Fit"
            ]
          }
        ],

        /* -----------------
           SECOND ROW
        ------------------ */
        second_row: [
          {
            id: "S210",
            name: "Bench Seat",
            price: 260.40,
            compare_at: 372.00,
            image: "https://www.nwseatcovers.com/uploads/seats/full/G212B.gif",
            features: [
              "Fold Down Backrest",
              "Free Map Pockets"
            ]
          },
          {
            id: "S211",
            name: "Bench w/ Armrest",
            price: 260.40,
            compare_at: 372.00,
            image: "https://www.nwseatcovers.com/uploads/seats/full/G212A.gif",
            features: [
              "Fold Down Armrest",
              "Cup Holder Access"
            ]
          }
        ],

        /* -----------------
           THIRD ROW
        ------------------ */
        third_row: [
          {
            id: "T101",
            name: "Split Bench",
            price: 210.40,
            compare_at: 310.00,
            image: "https://www.nwseatcovers.com/uploads/seats/full/G212.gif",
            features: [
              "60/40 Split",
              "Easy Fold Design"
            ]
          },
          {
            id: "T102",
            name: "Full Bench",
            price: 210.40,
            compare_at: 310.00,
            image: "https://www.nwseatcovers.com/uploads/seats/full/G212C.gif",
            features: [
              "One-Piece Bench",
              "Rear Seat Protection"
            ]
          }
        ]

      }
    }
  }
};
